exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":root {\n  --danger-color: #ff5e49;\n  --dark-color: #34363a;\n  --grey-color: #f5f5f5;\n  --spacing-default: .375rem;\n}\n", ""]);

// exports
